<script setup lang="ts"></script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    width="1em"
    height="1em"
    viewBox="0 0 704 704"
    aria-hidden="true"
  >
    <defs>
      <filter
        id="master_svg0_62_10054"
        filterUnits="objectBoundingBox"
        color-interpolation-filters="sRGB"
        x="-0.030120481927710843"
        y="-0.030120481927710843"
        width="1.0602409638554218"
        height="1.0602409638554218"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur stdDeviation="5" result="effect1_foregroundBlur" />
      </filter>
      <linearGradient
        id="master_svg1_62_10082"
        x1="0.5"
        y1="-0.13192443549633026"
        x2="0.42319029569625854"
        y2="1.368432641029358"
      >
        <stop
          offset="9.145302325487137%"
          stop-color="currentColor"
          stop-opacity="1"
        />
        <stop
          offset="13.636428117752075%"
          stop-color="currentColor"
          stop-opacity="0.07539999485015869"
        />
        <stop
          offset="16.968481242656708%"
          stop-color="currentColor"
          stop-opacity="0"
        />
      </linearGradient>
    </defs>
    <g
      transform="matrix(0,1,-1,0,704,-664)"
      filter="url(#master_svg0_62_10054)"
    >
      <path
        d="M1016,684C1199.359,684,1348,535.359,1348,352C1348,168.641,1199.359,20,1016,20C832.641,20,684,168.641,684,352C684,535.359,832.641,684,1016,684ZM1016,32C1192.731,32,1336,175.269,1336,352C1336,528.731,1192.731,672,1016,672C839.269,672,696,528.731,696,352C696,175.269,839.269,32,1016,32Z"
        fill-rule="evenodd"
        fill="url(#master_svg1_62_10082)"
        fill-opacity="1"
      />
    </g>
  </svg>
</template>

<style scoped>
svg {
  display: block;
}
</style>
